import type { Enums, Tables } from '../../types/database.types';

/**
 * Supplier exchange: the two-way portal.
 * Lane 1 (TAP -> supplier): handoffs the supplier acknowledges.
 * Lane 2 (supplier -> TAP): sample submissions TAP decides on; approval
 * auto-creates a "Track order" project (the database owns that rule).
 */

export type SupplierSubmission = Tables<'supplier_submissions'>;
export type SubmissionPhoto = Tables<'submission_photos'>;
export type SupplierHandoff = Tables<'supplier_handoffs'>;
export type HandoffLink = Tables<'handoff_links'>;
export type SubmissionStatus = Enums<'submission_status'>;

export const SUBMISSION_STATUS_LABELS: Record<SubmissionStatus, string> = {
  submitted: 'Awaiting TAP review',
  approved: 'Approved for production',
  revision_requested: 'Revision requested',
  on_hold: 'On hold',
};

export const SUBMISSION_STATUS_TONES: Record<
  SubmissionStatus,
  'brand' | 'success' | 'warning' | 'neutral'
> = {
  submitted: 'brand',
  approved: 'success',
  revision_requested: 'warning',
  on_hold: 'neutral',
};

/** Comma-separated tags to clean display chips. */
export function splitTags(tags: string): string[] {
  return tags
    .split(',')
    .map((tag) => tag.trim())
    .filter((tag) => tag !== '');
}

export function exchangeErrorMessage(message: string): string {
  if (message.includes('submission_decision_requires_admin')) {
    return 'Only a TAP admin, or an Admin on Supplier Reviews, can decide on a submission.';
  }
  if (message.includes('submission_is_closed')) {
    return 'This submission has been decided and can no longer be edited.';
  }
  if (message.includes('handoff_already_acknowledged')) {
    return 'This handoff was already acknowledged.';
  }
  if (message.includes('handoff_content_is_tap_owned')) {
    return 'Only TAP can edit the handoff itself — add your note when acknowledging.';
  }
  if (message.includes('drive_reconnect_required')) {
    // Not "sign out and back in": a normal sign-in never requests offline
    // access, so that cannot mint a refresh token and never fixed this.
    return 'Google Drive needs reconnecting — use Reconnect Google Drive in the account menu.';
  }
  return 'That change could not be saved. Try again.';
}
